import { render, staticRenderFns } from "./Two.vue?vue&type=template&id=3c7ae1bc&scoped=true"
import script from "./Two.vue?vue&type=script&lang=js"
export * from "./Two.vue?vue&type=script&lang=js"
import style0 from "./Two.vue?vue&type=style&index=0&id=3c7ae1bc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c7ae1bc",
  null
  
)

export default component.exports